import { appendWhatsAppTrackingCode, hasWhatsAppRecipient, isWhatsAppUrl } from '~/utils/whatsappTracking'

export default defineNuxtPlugin((nuxtApp) => {
  const tracking = useTracking()
  const publicCallActions = usePublicCallActions()
  const config = useRuntimeConfig()
  let lastPage = ''

  const trackCurrentPage = () => {
    tracking.refreshAttribution()
    const currentPage = `${window.location.pathname}${window.location.search}`
    if (currentPage === lastPage) return
    if (tracking.trackPageView()) lastPage = currentPage
  }

  nuxtApp.hook('page:finish', trackCurrentPage)

  const openTrackedWhatsApp = async (
    href: string,
    link: HTMLAnchorElement,
    attribution: Record<string, unknown> | null
  ) => {
    const openInNewTab = link.target === '_blank'
    const popup = openInNewTab ? window.open('about:blank', '_blank') : null
    if (popup) popup.opener = null

    let destination = href
    try {
      const response = await fetch(`${String(config.public.apiBase).replace(/\/$/, '')}/wapp/attribution-link`, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attribution,
          tourId: document.body.dataset.tourId || '',
          page: window.location.pathname
        })
      })
      const payload = await response.json()
      if (response.ok && payload?.code) destination = appendWhatsAppTrackingCode(href, payload.code)
    } catch (error) {
      console.warn('[tracking] WhatsApp kaynak kodu oluşturulamadı:', error)
    }

    if (popup && !popup.closed) popup.location.href = destination
    else if (openInNewTab) {
      const nextWindow = window.open(destination, '_blank', 'noopener')
      if (!nextWindow) window.location.assign(destination)
    }
    else window.location.assign(destination)
  }

  const handleTrackedLink = (event: MouseEvent) => {
    const target = event.target as Element | null
    const link = target?.closest?.('a[href]') as HTMLAnchorElement | null
    if (!link) return

    const href = link.href || ''
    if (isWhatsAppUrl(href)) {
      tracking.trackEvent('whatsapp_click', {
        link_domain: new URL(href).hostname,
        link_text: (link.textContent || link.getAttribute('aria-label') || '').trim(),
        page_path: window.location.pathname,
        tour_id: document.body.dataset.tourId || ''
      })
      const attribution = tracking.getAttributionPayload()
      if (
        hasWhatsAppRecipient(href)
        && !window.location.pathname.startsWith('/admin/')
        && !window.location.pathname.startsWith('/agent/')
      ) {
        event.preventDefault()
        event.stopPropagation()
        void openTrackedWhatsApp(href, link, attribution)
      }
    } else if (href.startsWith('tel:')) {
      tracking.trackEvent('phone_click', {
        page_path: window.location.pathname,
        link_text: (link.textContent || link.getAttribute('aria-label') || '').trim()
      })
      if (!window.location.pathname.startsWith('/admin/')) {
        event.preventDefault()
        publicCallActions.openDialog({
          destination: href,
          label: (link.textContent || link.getAttribute('aria-label') || '').trim()
        })
      }
    }
  }

  document.addEventListener('click', handleTrackedLink, { capture: true })
  window.addEventListener('cookie-consent-updated', (event) => {
    if ((event as CustomEvent)?.detail === 'accepted') trackCurrentPage()
    else {
      lastPage = ''
      tracking.clearAttribution()
    }
  })
})
